/* ── Aykah Wishlist ──────────────────────────────────────────────────────────
   localStorage-based wishlist. Additive, self-contained, no dependencies.
   - Heart toggles: [data-wl-toggle] (cards) + [data-wl-toggle].wl-btn-pdp (PDP).
   - Header icon + count: [data-wl-count], [data-wl-open] (opens drawer).
   - Slide-in drawer: [data-wl-drawer] (+ overlay, items, empty, close).
   - Toast feedback on add.
   - Full page (optional): #wl-grid / #wl-empty.
   Event delegation throughout so dynamically-loaded cards work. */
(function () {
  'use strict';
  var KEY = 'aykah_wishlist';

  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function set(items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} updateCount(items.length); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function snapshot(btn) { var d = btn.dataset; return { handle: d.wlHandle, id: d.wlId, title: d.wlTitle, url: d.wlUrl, image: d.wlImage, price: d.wlPrice }; }

  function setBtn(btn, active, animate) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Save to wishlist');
    if (active && animate) { btn.classList.add('just-added'); setTimeout(function () { btn.classList.remove('just-added'); }, 400); }
  }
  function syncHearts() {
    var items = get();
    document.querySelectorAll('[data-wl-toggle]').forEach(function (btn) {
      setBtn(btn, items.some(function (i) { return i.handle === btn.dataset.wlHandle; }), false);
    });
  }
  function updateCount(n) {
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('wl-count-empty', n === 0);
    });
  }

  function toggle(btn) {
    var items = get(), h = btn.dataset.wlHandle;
    var idx = items.findIndex(function (i) { return i.handle === h; });
    var active;
    if (idx > -1) { items.splice(idx, 1); active = false; } else { items.push(snapshot(btn)); active = true; }
    set(items);
    syncHearts();
    setBtn(btn, active, true);
    renderDrawer();
    renderPage();
    showToast(active ? 'Added to your wishlist' : 'Removed from wishlist', active);
  }

  // ── item card markup (shared by drawer + page) ──
  function itemRow(i, variant) {
    var cls = variant === 'drawer' ? 'wl-drawer-item' : 'wl-card';
    return '<div class="' + cls + '" data-wl-card="' + esc(i.handle) + '">' +
      '<a class="' + cls + '-media" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="' + cls + '-info">' +
        '<a class="' + cls + '-title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
        (i.price ? '<div class="' + cls + '-price">' + esc(i.price) + '</div>' : '') +
        (variant === 'page' ? '<a class="wl-card-cta" href="' + esc(i.url) + '">View product</a>' : '') +
      '</div>' +
      '<button type="button" class="' + cls + '-remove" data-wl-remove="' + esc(i.handle) + '" aria-label="Remove from wishlist">&times;</button>' +
    '</div>';
  }

  function renderDrawer() {
    var wrap = document.querySelector('[data-wl-drawer-items]');
    if (!wrap) return;
    var empty = document.querySelector('[data-wl-drawer-empty]');
    var foot = document.querySelector('[data-wl-drawer-foot]');
    var items = get();
    if (!items.length) {
      wrap.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      if (foot) foot.classList.add('hidden');
      return;
    }
    if (empty) empty.classList.add('hidden');
    if (foot) foot.classList.remove('hidden');
    wrap.innerHTML = items.map(function (i) { return itemRow(i, 'drawer'); }).join('');
  }

  function renderPage() {
    var grid = document.getElementById('wl-grid');
    if (!grid) return;
    var empty = document.getElementById('wl-empty');
    var items = get();
    if (!items.length) { grid.innerHTML = ''; grid.classList.add('hidden'); if (empty) empty.classList.remove('hidden'); return; }
    if (empty) empty.classList.add('hidden');
    grid.classList.remove('hidden');
    grid.innerHTML = items.map(function (i) { return itemRow(i, 'page'); }).join('');
  }

  // ── drawer open/close ──
  function openDrawer() {
    var d = document.querySelector('[data-wl-drawer]'), o = document.querySelector('[data-wl-overlay]');
    if (!d) return;
    renderDrawer();
    d.classList.add('wl-open'); d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('wl-open');
    document.body.classList.add('wl-drawer-lock');
  }
  function closeDrawer() {
    var d = document.querySelector('[data-wl-drawer]'), o = document.querySelector('[data-wl-overlay]');
    if (d) { d.classList.remove('wl-open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('wl-open');
    document.body.classList.remove('wl-drawer-lock');
  }

  // ── toast ──
  var toastTimer;
  function showToast(msg, withView) {
    var t = document.querySelector('[data-wl-toast]');
    if (!t) return;
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (withView ? ' <button type="button" class="wl-toast-view" data-wl-open>View</button>' : '');
    t.classList.add('wl-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('wl-show'); }, 2800);
  }

  // ── delegated clicks ──
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var toggleBtn = e.target.closest('[data-wl-toggle]');
    if (toggleBtn) { e.preventDefault(); e.stopPropagation(); toggle(toggleBtn); return; }
    var openBtn = e.target.closest('[data-wl-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wl-close]') || e.target.matches('[data-wl-overlay]')) { closeDrawer(); return; }
    var rm = e.target.closest('[data-wl-remove]');
    if (rm) {
      var h = rm.getAttribute('data-wl-remove');
      set(get().filter(function (i) { return i.handle !== h; }));
      syncHearts(); renderDrawer(); renderPage();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function init() { syncHearts(); updateCount(get().length); renderDrawer(); renderPage(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
